import { useCallback, useEffect, useState } from 'react';

import { fetchAppConfig } from 'lib/models/appConfig';

function useAppConfig() {
	const [loading, setLoading] = useState<boolean>(true);

	const [appConfig, setAppConfig] = useState<AppConfig>({
		conditions: { es: '' },
		policy: { es: '' },
		privacy: { es: '' },
		deletion: { es: '' },
		muteHelpPhone: '',
		walletHelpPhone: '',
		onBoardingUrl: '',
	});

	const getAppConfig = useCallback(async () => {
		const response = await fetchAppConfig();
		setAppConfig(response);

		setLoading(false);
	}, []);

	useEffect(() => {
		getAppConfig();
	}, [getAppConfig]);

	return { loading, appConfig, getAppConfig };
}

export default useAppConfig;
